import { useState } from "react";
import { Link } from "react-router-dom";
import { supabase } from "../utils/supabaseClient";

export default function ResetPassword() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    setStatus("");
    setError("");
    setLoading(true);

    try {
      const { error: resetError } = await supabase.auth.resetPasswordForEmail(email.trim(), {
        // Works on localhost and on your live site (the old version always pointed at localhost)
        redirectTo: `${window.location.origin}/update-password`,
      });

      if (resetError) {
        setError(resetError.message);
      } else {
        setStatus("If an account exists for that email, a password reset link is on its way.");
      }
    } catch (err) {
      console.error("Password reset failed:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth">
      <div className="auth-card">
        <h2 className="auth-title">Reset your password</h2>
        <p className="auth-sub">Enter your email and we'll send you a reset link.</p>

        <form onSubmit={handleSubmit}>
          {status && (
            <p className="ui-alert ui-alert--ok" role="status">
              {status}
            </p>
          )}
          {error && (
            <p className="ui-alert ui-alert--error" role="alert">
              {error}
            </p>
          )}

          <div className="ui-field">
            <label className="ui-label" htmlFor="reset-email">Email address</label>
            <input
              id="reset-email"
              className="ui-input"
              type="email"
              placeholder="you@example.com"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <button
            type="submit"
            className="ui-btn ui-btn--primary ui-btn--block"
            disabled={loading}
          >
            {loading ? "Sending..." : "Send reset link"}
          </button>
        </form>

        <p className="auth-foot">
          Remembered it? <Link to="/login">Back to login</Link>
        </p>
      </div>
    </div>
  );
}